export default {
    data(){
        return {
            modalStatusData: {
                state: false
            },
            modalSearchStatus: {
                state: false
            },
            newCheckAll: [],
            exportSearchData: {},
            exportTitle:'导出选中',
            exportSearchTitle:'导出检索结果',
            exportFormName: '',
            exportModalForm: {
                name: ''//绑定导出文件名 传入ExportModal组件 组件内接收属性为formModel
            }
        }
    },
    watch: {
        modalStatusData: {
            handler(newVal) {
                if (newVal.state) {
                    this.exportModalForm.name = this.exportFormName;
                }
            },
            deep: true
        },
        modalSearchStatus: {
            handler(newVal) {
                if (newVal.state) {
                    this.exportModalForm.name = this.exportFormName;
                }
            },
            deep: true
        }
    },
    methods: {
        /**
         * 导出检索结果处理方法
         */
        handleExportSearch(newCheckAll) {
            this.modalSearchStatus.state = true;
        },
        /**
         * 导出选中处理方法
         * @param {Array} newCheckAll 选中数组id
         */
        handleExport(newCheckAll) {
            if (newCheckAll.length > 0) {
                this.modalStatusData.state = true;
                this.newCheckAll = newCheckAll;
            } else {
                this.$Message.error({
                    content: '请勾选导出数据',
                    duration: 2
                });
            }
        },
    },
}